import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TimeSheetTaskWithoutDays } from '@app/time-sheet/models/time-sheet-task';
import { MonthYearSelector } from '@components/month-year-selector/month-year-selector';

import { subMonths } from 'date-fns';

import { UploadTimeSheetCard } from './components/upload-time-sheet-card/upload-time-sheet-card';
import { UploadTimeSheetService } from './service/upload-time-sheet-service';

@Component({
  selector: 'abc-upload-time-sheet',
  imports: [MonthYearSelector, UploadTimeSheetCard],
  templateUrl: 'upload-time-sheet.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadTimeSheet {
  uploadTimeSheetService = inject(UploadTimeSheetService);

  previousMonth = subMonths(new Date(), 1);

  selectedYear = signal<number>(this.previousMonth.getFullYear());
  selectedMonth = signal<number>(this.previousMonth.getMonth() + 1);

  tasks = signal<TimeSheetTaskWithoutDays[] | null>(null);
  filteredTasks = computed(() => {
    return (
      this.tasks()?.filter(
        (task) => !task.readOnly && task.completed && !task.finalised && task.isProductive
      ) || []
    );
  });

  constructor() {
    effect(() => {
      this.tasks.set(null);
      this.uploadTimeSheetService.refreshTasks(this.selectedYear(), this.selectedMonth());
    });

    this.uploadTimeSheetService.tasks$
      .pipe(takeUntilDestroyed())
      .subscribe((data: TimeSheetTaskWithoutDays[]) => {
        this.tasks.set(data);
      });
  }
}
